import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BellRing, Check, ChevronDown, ChevronRight, Copy, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { PlatformBadge } from "@/components/Badges";
import { api, errMsg, money } from "@/lib/api";

const jourLocal = () => { const n = new Date(); return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}-${String(n.getDate()).padStart(2, "0")}`; };

const Relance = ({ d, onFait }) => {
  const [ouvert, setOuvert] = useState(false);
  const [busy, setBusy] = useState(false);
  const r = d.resume || {};
  const copier = () => navigator.clipboard.writeText(d.message_relance).then(() => toast.success("Message de relance copié")).catch(() => toast.error("Copie impossible : sélectionnez le texte"));
  const marquer = async () => {
    setBusy(true);
    try { await api.post(`/demandes/${d.id}/relances`, { date: jourLocal() }); toast.success("Relance enregistrée : prochain rappel dans 15 jours"); onFait(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <li className="border-t border-amber-200/70 py-3 first:border-t-0" data-testid={`relance-${d.id}`}>
      <div className="flex flex-wrap items-center gap-3 text-sm">
        <button type="button" onClick={() => setOuvert(!ouvert)} className="flex items-center gap-2 text-left" data-testid={`relance-voir-${d.id}`}>
          {ouvert ? <ChevronDown className="h-4 w-4 text-amber-700" /> : <ChevronRight className="h-4 w-4 text-amber-700" />}
          <PlatformBadge plateforme={d.plateforme} />
          <span className="font-medium text-slate-800">{r.code || "Calcul libre"}{r.nom_client ? ` · ${r.nom_client}` : ""}</span>
        </button>
        <span className="text-xs text-slate-600" data-testid={`relance-jours-${d.id}`}>envoyée le {d.date_envoi}{d.relances.length ? ` · ${d.relances.length} relance(s)` : ""} · sans réponse depuis {d.jours} jours</span>
        <span className="tabular font-semibold text-red-700">{money(d.montant)}</span>
        <div className="ml-auto flex gap-2">
          <Button size="sm" variant="outline" className="h-8 bg-white" onClick={copier} data-testid={`relance-copier-${d.id}`}><Copy className="mr-1 h-3.5 w-3.5" />Copier</Button>
          <Button size="sm" className="h-8" disabled={busy} onClick={marquer} data-testid={`relance-marquer-${d.id}`}>{busy ? <Loader2 className="mr-1 h-3.5 w-3.5 animate-spin" /> : <Check className="mr-1 h-3.5 w-3.5" />}Marquer comme relancé</Button>
        </div>
      </div>
      {ouvert && <pre className="mt-3 max-h-72 overflow-auto whitespace-pre-wrap rounded-md border border-amber-200 bg-white p-3 font-sans text-xs text-slate-700" data-testid={`relance-texte-${d.id}`}>{d.message_relance}</pre>}
    </li>
  );
};

export const RappelDemandes = () => {
  const [liste, setListe] = useState([]);
  const charger = useCallback(() => { api.get("/demandes/a-relancer", { params: { jour: jourLocal() } }).then((r) => setListe(r.data)).catch(() => {}); }, []);
  useEffect(() => { charger(); }, [charger]);
  if (!liste.length) { return null; }
  return (
    <div className="mb-6 rounded-lg border border-amber-300 bg-amber-50/70 px-5 py-4" data-testid="rappel-demandes">
      <div className="mb-1 flex flex-wrap items-center gap-2 text-sm font-semibold text-amber-900">
        <BellRing className="h-4 w-4" />{liste.length} demande(s) aux plateformes sans réponse depuis 15 jours ou plus
        <Link to="/demandes" className="ml-auto text-xs font-medium text-amber-800 hover:underline" data-testid="rappel-demandes-lien">Voir toutes les demandes</Link>
      </div>
      <ul>{liste.map((d) => <Relance key={d.id} d={d} onFait={charger} />)}</ul>
    </div>
  );
};
